import { useStore } from '../store';
import { PermissionSlug } from '../constants/featureFlags';

/**
 * Whether this user may change a task's date from the Hotbox list.
 *
 * Separate from `hotbox:access`, and only this slug counts — the route gates on
 * `hotbox:reschedule` alone, so widening it here would show an enabled picker
 * to users whose every save is rejected.
 */
export function useCanRescheduleFromHotbox(): boolean {
  const hasPermission = useStore(state => state.hasPermission);
  return hasPermission(PermissionSlug.HOTBOX_RESCHEDULE);
}
